import { Link, useNavigate } from 'react-router-dom';
import { NavDropdown } from 'react-bootstrap';
import { useAuth } from '../auth';
import Avatar from './Avatar';
import { roleLabel } from './roleLabels';

// The top-menu account control: an avatar icon that opens a dropdown showing the signed-in
// user's name, email and role(s), a link to the full Account details page, and Log out.
// Replaces the old "Hi, {name}" (disabled) + "Log out" nav links.
export default function AccountMenu() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  if (!user) return null;

  const roles = user.roles?.length ? user.roles : [user.role].filter(Boolean);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <NavDropdown
      align="end"
      id="account-menu"
      title={
        <>
          <Avatar name={user.name} email={user.email} size={30} />
          <span className="visually-hidden">Account menu for {user.name}</span>
        </>
      }
    >
      <div className="px-3 py-2" style={{ maxWidth: 260 }}>
        <div className="fw-semibold text-truncate">{user.name}</div>
        <div className="text-muted small text-truncate">{user.email}</div>
        <div className="mt-1 d-flex flex-wrap gap-1">
          {roles.map((r) => (
            <span key={r} className="badge bg-secondary">{roleLabel(r)}</span>
          ))}
        </div>
      </div>
      <NavDropdown.Divider />
      {/* homepage/user_experience.md #7 - a logged-in customer reaches their visits / status /
          upcoming appointments straight from the account menu. */}
      {roles.includes('customer') && (
        <>
          <NavDropdown.Item as={Link} to="/my-visits">My visits</NavDropdown.Item>
          <NavDropdown.Divider />
        </>
      )}
      <NavDropdown.Item as={Link} to="/account">Account details</NavDropdown.Item>
      <NavDropdown.Item as={Link} to="/pricing">Pricing &amp; plans</NavDropdown.Item>
      <NavDropdown.Item as={Link} to="/account/password">Change password</NavDropdown.Item>
      <NavDropdown.Divider />
      <NavDropdown.Item onClick={handleLogout}>Log out</NavDropdown.Item>
    </NavDropdown>
  );
}
